import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.InstagramContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    contextClasses.push Monitoring.Views.InstagramContentParentMediaView
    contextClasses.push Monitoring.Views.InstagramContentPreviousCommentsView if @rootParentId != @socialContent.numeric_id()
    contextClasses.push Monitoring.Views.InstagramContentFollowingCommentsView

    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
